module.exports = __webpack_public_path__ + "static/img/en16.be99d4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/en16.jpg
// module id = rpY5
// module chunks = 1